Pegasus.IteratorFunction = Em.Object.extend({});
Pegasus.ChangeHeadersIteratorFunction = Pegasus.IteratorFunction.extend({
  blocks: [],
  hints: {
    // Headers are generally the largest text in a block
    isLargestFont: {
      weight: 36
    },
    // They usually don't contain links
    isAnchorless: {
      weight: 34
    },
    // Headers are short
    isBrief: {
      weight: 20
    },
    // They are pretty big too
    isMinimumFontSize: {
      weight: 5
    },
    // They stand out as a secondary color
    isSecondaryColor: {
      weight: 5
    }
  }
});


Pegasus.EditingDocumentController = Em.ObjectController.extend({
  changeRowColor: function(color, iteratorFunction){
    this.get('childViews').forEach(iteratorFunction(color));
  },
  changeHeaderColor: function(color, iteratorFunction){
    this.get('childViews').forEach(iteratorFunction(color));
  },
  changeParagraphColor: function(color, iteratorFunction){
    this.get('childViews').forEach(iteratorFunction(color));
  }
});
